import { EVENTS } from '../types'

export const EventsReducer = (state = [], action) =>{
  const {type, payload} = action

  switch (type) {
    case EVENTS: {
        const { data } = payload
        state = []
        return data
    }
    default: {
      return state
    }
  }
}
